/** How far a resize hit area extends into the panel past the surface edge. */
export const RESIZE_HANDLE_INSIDE_PX = 2
/** How far a resize hit area extends outside the surface into the gutter. */
export const RESIZE_HANDLE_OUTSIDE_PX = 4
/** Total grab-strip thickness along the axis being resized. */
export const RESIZE_HANDLE_SIZE_PX = RESIZE_HANDLE_INSIDE_PX + RESIZE_HANDLE_OUTSIDE_PX

/** The panel content's `p-3` — how far the visible card is inset from the root. */
export const SURFACE_INSET_PX = 12
/**
 * The surface card's corner radius (`rounded-2xl`, `--radius-lg`). Edge hover lines span only
 * the straight part of the edge, so they stop where the corner starts curving.
 */
export const SURFACE_RADIUS = 'var(--radius-lg)'
/** `SURFACE_RADIUS` less the handle's inside reach: where a hover line starts, measured from the strip's own edge. */
export const SURFACE_RADIUS_INSIDE = `calc(${SURFACE_RADIUS} - ${RESIZE_HANDLE_INSIDE_PX}px)`

/** The translucent outline every resize handle draws where the surface will land. */
export const RESIZE_PREVIEW_CLASS =
  'corner-smooth pointer-events-none absolute z-50 rounded-2xl border-2 border-on-dark bg-black-7'
